import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-box3-overig',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-box3-overig.component.html',
    styleUrl: './tekst-box3-overig.component.scss',
})
export class TekstBox3OverigComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public vrijstellingContantGeld = 0
    public bedragUitvaartverzekering = 0
    public bedragKapitaalverzekering = 0
    public bedragJaarloonNettoPensioen = 0
    public bedragPeriodiekeUitkeringen = 0

    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year == 2024) {
                this.vrijstellingContantGeld = 653
                this.bedragUitvaartverzekering = 8665
                this.bedragKapitaalverzekering = 123428
                this.bedragJaarloonNettoPensioen = 137800
                this.bedragPeriodiekeUitkeringen = 2269
            } else if (this.year == 2025) {
                this.vrijstellingContantGeld = 661
                this.bedragUitvaartverzekering = 8769
                this.bedragKapitaalverzekering = 123428
                this.bedragJaarloonNettoPensioen = 145951
                this.bedragPeriodiekeUitkeringen = 2269
            } else if (this.year == 2026) { // todo
                this.vrijstellingContantGeld = 672
                this.bedragUitvaartverzekering = 8904
                this.bedragKapitaalverzekering = 123428
                this.bedragJaarloonNettoPensioen = 145951
                this.bedragPeriodiekeUitkeringen = 2269
            }
        })
    }

}
